import { FC } from 'react'
import { TextInput } from './Text'
import { useTranslation } from 'react-i18next'
import { SupportedMarket } from '@estercare/ester-shared'
import { isNorwegianMarket } from '../../utils/market'

interface FormattedZipCodeInputProps {
  value: string
  backgroundColor?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  error?: string
  highlight?: boolean
  market?: SupportedMarket
}

export const ZipCodeInput: FC<FormattedZipCodeInputProps> = ({
  value,
  backgroundColor,
  onChange,
  error,
  highlight,
  market,
}) => {
  const { t } = useTranslation()
  const isNorwegian = isNorwegianMarket(market)
  const formatZipCode = (val: string) => {
    if (isNorwegian) {
      return val.replace(/\D/g, '').slice(0, 4)
    }
    const digits = val.replace(/\D/g, '').slice(0, 5)
    return digits.length > 3 ? `${digits.slice(0, 3)} ${digits.slice(3)}` : digits
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/\D/g, '')
    onChange({ ...e, target: { ...e.target, value: rawValue } })
  }

  return (
    <TextInput
      label={t('common.welcome.zipCode')}
      backgroundColor={backgroundColor}
      placeholder={isNorwegian ? '1234' : '123 45'}
      value={formatZipCode(value)}
      onChange={handleChange}
      maxLength={isNorwegian ? 4 : 6}
      inputMode="numeric"
      pattern="[0-9]*"
      error={error}
      highlight={highlight}
    />
  )
}
